import React from "react";
const VideoCallIcon: React.FC = () => {
  return (
    <svg
      width="29"
      height="24"
      viewBox="0 0 29 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1539 17.75H13.0539V13.4375H17.4039V10.5625H13.0539V6.25H10.1539V10.5625H5.80391V13.4375H10.1539V17.75ZM2.90391 23.5C2.10641 23.5 1.42394 23.2187 0.856506 22.6562C0.289073 22.0936 0.00487292 21.4166 0.00390625 20.625V3.375C0.00390625 2.58437 0.288106 1.90779 0.856506 1.34525C1.42491 0.782708 2.10737 0.500958 2.90391 0.5H20.3039C21.1014 0.5 21.7844 0.78175 22.3528 1.34525C22.9212 1.90875 23.2049 2.58533 23.2039 3.375V9.84375L29.0039 4.09375V19.9062L23.2039 14.1562V20.625C23.2039 21.4156 22.9202 22.0927 22.3528 22.6562C21.7853 23.2197 21.1024 23.501 20.3039 23.5H2.90391Z"
        fill="#D4D6D9"
      />
    </svg>
  );
};

export default VideoCallIcon;
